import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FilterChipActionsDirective,
  FilterChipContainerComponent,
  FilterMenuItemsDirective,
} from './filter-chips-container/filter-chip-container.component';
import {
  FilterChipComponent,
  FilterChipTitleDirective,
  FilterChipValueDirective,
} from './filter-chip/filter-chip.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';
import { MatRippleModule } from '@angular/material/core';

@NgModule({
  declarations: [
    FilterChipContainerComponent,
    FilterChipComponent,
    FilterMenuItemsDirective,
    FilterChipActionsDirective,
    FilterChipTitleDirective,
    FilterChipValueDirective,
  ],
  exports: [
    FilterChipContainerComponent,
    FilterChipComponent,
    FilterMenuItemsDirective,
    FilterChipActionsDirective,
    FilterChipTitleDirective,
    FilterChipValueDirective,
  ],
  imports: [CommonModule, MatButtonModule, MatIconModule, MatMenuModule, TranslateModule, MatRippleModule],
})
export class FilterChipsModule {}
